import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

const META = {
  terms: {
    title: "Terms of Service — GC Nexon",
    description: "Read the Terms of Service governing gift card buyback transactions on GC Nexon. Covers submissions, payouts, disputes, and fraud policy.",
  },
  privacy: {
    title: "Privacy Policy — GC Nexon",
    description: "How GC Nexon collects, uses, and protects your personal and gift card information. Data retention, encryption, and your rights.",
  },
  cookies: {
    title: "Cookie Policy — GC Nexon",
    description: "How GC Nexon uses cookies for authentication, analytics, and fraud prevention. Manage your cookie preferences.",
  },
  refund: {
    title: "Refund & Payout Policy — GC Nexon",
    description: "Refund and payout guarantees for gift card sellers. Timelines, dispute process, and payout method-specific policies.",
  },
  acceptable: {
    title: "Acceptable Use Policy — GC Nexon",
    description: "Rules governing how GC Nexon can be used. Prohibited activities, fraud enforcement, and account termination policies.",
  },
};

export default function Legal({ slug = "terms" }) {
  const meta = META[slug] || META.terms;
  useSeo({
    title: meta.title,
    description: meta.description,
    path: `/legal/${slug}`,
  });
  return (
    <WebflowPage
      htmlPath={`/site/legal.html?slug=${encodeURIComponent(slug)}`}
      title={meta.title}
    />
  );
}
